import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [RouterLink],
  template: `
    <div class="flex h-screen flex-col items-center justify-center p-6 text-center">
      <div class="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-error/10 text-error">
        <i class="fa-solid fa-shield-halved text-5xl"></i>
      </div>
      <h1 class="text-4xl font-black tracking-tight text-base-content">Access Denied</h1>
      <p class="mt-4 max-w-md text-lg font-medium text-base-content/60">
        You don't have the required permissions to view this command center. 
        Please contact a Super Admin if you believe this is a mistake.
      </p>
      <div class="mt-10 flex gap-4">
        <button class="btn btn-primary px-8 rounded-2xl shadow-xl shadow-primary/20" [routerLink]="auth.homePath()">
          Back to my workspace
        </button>
      </div>
    </div>
  `
})
export class UnauthorizedComponent { readonly auth = inject(AuthService); }
